import React from 'react';
import type {
  VisualPromptAnswers,
  VisualPromptAnswerValue,
  VisualPromptDefinition,
  VisualPromptStep,
} from '@/types/visualPrompts/visualPrompt.types';
import { isCompiledPreviewThin } from '@/utils/visualPrompts/compileVisualPrompt';
import { VisualPromptMultiSelectStep } from '../steps/VisualPromptMultiSelectStep';
import { VisualPromptReviewStep } from '../steps/VisualPromptReviewStep';
import type { VisualPromptReviewContext } from '../steps/VisualPromptReviewStep/types';
import { VisualPromptSingleSelectStep } from '../steps/VisualPromptSingleSelectStep';
import { VisualPromptTextStep } from '../steps/VisualPromptTextStep';

export interface RenderWizardStepOptions {
  reviewContext?: VisualPromptReviewContext;
  definition?: VisualPromptDefinition | null;
  onSaveChoices?: () => void;
}

export const renderWizardStep = (
  step: VisualPromptStep,
  answers: VisualPromptAnswers,
  onAnswer: (mapsTo: string, value: VisualPromptAnswerValue) => void,
  stepError: string | null,
  compiledPreview: string,
  options?: RenderWizardStepOptions,
): React.ReactNode => {
  switch (step.type) {
    case 'singleSelect':
    case 'singleSelectPills':
      return (
        <VisualPromptSingleSelectStep
          step={step}
          answers={answers}
          onAnswer={onAnswer}
          error={stepError}
        />
      );
    case 'multiSelect':
      return (
        <VisualPromptMultiSelectStep
          step={step}
          answers={answers}
          onAnswer={onAnswer}
          error={stepError}
        />
      );
    case 'text':
    case 'textarea':
      return (
        <VisualPromptTextStep
          step={step}
          answers={answers}
          onAnswer={onAnswer}
          error={stepError}
        />
      );
    case 'review':
      return (
        <VisualPromptReviewStep
          compiledPreview={compiledPreview}
          reviewContext={options?.reviewContext}
          requiresContent={options?.definition?.requiresContent}
          previewIsThin={isCompiledPreviewThin(
            compiledPreview,
            options?.definition?.requiresContent,
          )}
          onSaveChoices={options?.onSaveChoices}
        />
      );
    default:
      return null;
  }
};
